import React, { FC } from 'react';
import cn from 'classnames';

import { colors } from '@crehana/ui';
import { Whatsapp, Facebook, Twitter, LinkedinClean } from '@crehana/icons';

import STRINGS from './i18n';

export type SocialNetwork = 'WhatsApp' | 'Facebook' | 'Twitter' | 'Linkedin';

interface ShareButtonProps {
  className?: string;
  socialNetwork: SocialNetwork;
  onShare: () => void;
}

const ShareButton: FC<ShareButtonProps> = ({
  className,
  socialNetwork,
  onShare,
}) => {
  const renderIcon = () => {
    const iconClassName =
      'w-32 h-32 mr-24 rounded-full flex items-center justify-center flex-shrink-0';

    if (socialNetwork === 'WhatsApp') {
      return (
        <div className={iconClassName} style={{ backgroundColor: '#25D366' }}>
          <Whatsapp size={16} color={colors.white} />
        </div>
      );
    }
    if (socialNetwork === 'Facebook') {
      return (
        <div className={iconClassName} style={{ backgroundColor: '#3B5998' }}>
          <Facebook size={16} color={colors.white} />
        </div>
      );
    }
    if (socialNetwork === 'Twitter') {
      return (
        <div className={iconClassName} style={{ backgroundColor: '#1DA1F2' }}>
          <Twitter size={12} color={colors.white} />
        </div>
      );
    }
    return (
      <div className={iconClassName} style={{ backgroundColor: '#0077B5' }}>
        <LinkedinClean size={14} color={colors.white} />
      </div>
    );
  };

  return (
    <button
      type="button"
      className={cn(
        'flex items-center font-button text-base-lighter focus:outline-none border border-solid border-base-lighter w-full pl-24 h-56',
        className,
      )}
      style={{ maxWidth: '294px' }}
      onClick={onShare}
    >
      {renderIcon()}
      {STRINGS.SHARE_LABEL({ socialNetwork })}
    </button>
  );
};

export default ShareButton;
